// extracted by mini-css-extract-plugin
module.exports = {"button":"edits_button__2MsGs","buttonGroup":"edits_buttonGroup__VCwWo","marginRight":"edits_marginRight__1oef3"};